import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRightIcon, PhoneIcon, ClockIcon } from "lucide-react";
import { company } from "../../data/navigation";
const certifications = ["RGE QualiPAC", "Qualigaz", "Professionnel du Gaz", "Garantie décennale", "Artisan depuis 2001"];
export function Hero() {
  return <section className="w-full bg-ink text-white" data-id="element-109" data-mp="aojw2pu2f2uw">
      <div className="mx-auto max-w-7xl px-5 pb-16 pt-16 md:px-8 md:pt-24" data-id="element-110" data-mp="apbgr5m4jg6e">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto max-w-5xl text-center" data-id="element-111" data-mp="5p7a07b0pztd">
          <h1 className="text-[44px] font-semibold leading-[1.02] tracking-tightest sm:text-6xl lg:text-[84px]" data-id="element-112" data-mp="3ry8b3tv0j6im">
            Plomberie et chauffage,
            <br className="hidden sm:block" data-id="element-113" data-mp="1q5k3z9f8zyxk" />{" "}
            <span className="text-lime" data-id="element-114" data-mp="1q63jyklc8d8y">installés pour durer.</span>
          </h1>
          <p className="mx-auto mt-7 max-w-2xl text-lg leading-relaxed text-white/70" data-id="element-115" data-mp="1mvjeq242e7vb">
            De la fuite sous l'évier à la pompe à chaleur, nos artisans certifiés
            interviennent chez vous à Lyon et alentours. Devis gratuit, prix
            annoncé, travaux garantis.
          </p>
          <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4" data-id="element-116" data-mp="1hy1323ynxejm">
            <Link to="/contact" className="group flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-lime px-8 py-4 text-base font-medium text-ink transition-colors duration-150 ease-out hover:bg-lime-hover sm:w-auto" data-id="element-117" data-mp="25o57gdjodibo">
              Demander un devis gratuit
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-118" data-mp="20u0zbqyob490" />
            </Link>
            <a href={company.phoneHref} className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border border-white/30 px-8 py-4 text-base font-medium text-white transition-colors duration-150 ease-out hover:border-white/60 sm:w-auto" data-id="element-119" data-mp="2te9aaip1he1m">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-120" data-mp="2p8m53r560dup" />
              Urgence : {company.phone}
            </a>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-16 grid gap-4 md:grid-cols-12" data-id="element-121" data-mp="2kb3rvok47cgw">
          <div className="relative overflow-hidden rounded-2xl md:col-span-5" data-id="element-122" data-mp="26ie87qs26jmy">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/f49060aa-5a48-486c-8391-b7610c22ebe0.jpg" alt="Technicien effectuant l'entretien d'une chaudière murale" className="h-72 w-full object-cover md:h-[440px]" data-id="element-123" data-mp="26gb7octa583z" />
          </div>
          <div className="relative overflow-hidden rounded-2xl md:col-span-7" data-id="element-124" data-mp="h10ho7342ba4">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/96b7458e-026f-4437-9a49-0b9644ce8fb9.jpg" alt="Plombier installant des tuyaux en cuivre sous un meuble vasque" className="h-72 w-full object-cover md:h-[440px]" data-id="element-125" data-mp="h33izn9prqu5" />
            <div className="absolute bottom-4 left-4 right-4 flex items-center gap-4 rounded-xl bg-white p-4 text-ink sm:right-auto sm:max-w-xs" data-id="element-126" data-mp="3pin4g04584yn">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-lime" data-id="element-127" data-mp="2bksuwn54fx2">
                <ClockIcon className="h-5 w-5" aria-hidden="true" data-id="element-128" data-mp="732tfjl94ehi" />
              </span>
              <div data-id="element-129" data-mp="36qudsccjqvu3">
                <p className="font-semibold leading-tight" data-id="element-130" data-mp="36p9l6s9slmyv">Dépannage en moins de 2 h</p>
                <p className="text-sm text-muted" data-id="element-131" data-mp="3ar4hficv9a5s">7j/7, y compris le week-end</p>
              </div>
            </div>
          </div>
        </motion.div>

        <ul aria-label="Certifications" className="mt-12 flex flex-wrap items-center justify-center gap-x-10 gap-y-3 border-t border-white/10 pt-8 text-sm font-medium text-white/55" data-id="element-132" data-mp="2rl6o7edd65gz">
          {certifications.map(c => <li key={c} className="whitespace-nowrap" data-id="element-133" data-mp="2wlcn9flyqu93">
              {c}
            </li>)}
        </ul>
      </div>
    </section>;
}